type EmptyContentType = 'sport' | 'search' | 'message' | 'favorite' | 'bets' | 'history';

interface EmptyContentMessageProps {
	type: EmptyContentType;
	title: string;
	children?: React.ReactNode;
}

export const EmptyContentMessage = ({ type, title, children }: EmptyContentMessageProps) => {
	return (
		<div className="empty">
			<div className={`empty__img empty__img--${type}`}></div>
			<div className="empty__title" dangerouslySetInnerHTML={{ __html: title }} />
			<div className="empty__text">
				{children}
			</div>
		</div>
	);
};